import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=390636f3&scoped=true&"
import script from "./ButtonIcon.vue?vue&type=script&lang=js&"
export * from "./ButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./ButtonIcon.vue?vue&type=style&index=0&id=390636f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390636f3",
  null
  
)

export default component.exports